var HCRequest = require('./core/HCRequest')

// function createInstance() {
//     var instance = new HCRequest();
//     return instance
//   }

// var hcRequest = createInstance()
module.exports = HCRequest
